<ng-template #groupTexture let-picturePath="picturePath">
  <div class="preview-wrapper" *ngIf="picturePath">
    <div class="img-wrapper w-8 h-8 flex flex-row justify-center items-center">
      <img class="preview" src="{{ getGroupTexturePath(picturePath) }}" />
    </div>
  </div>
</ng-template>

<ng-container *ngIf="data$ | async as data">
  <div *ngIf="!data.error">
    <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="tree">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle (click)="selectGroup(node.id)" class="selector">
        <li class="mat-tree-node" matRipple [ngClass]="{ accent: node.id === activeNodeId }">
          <button mat-icon-button disabled class="node-toggle-btn"></button>
          <ng-container *ngTemplateOutlet="groupTexture; context: { groupId: node.id }"></ng-container>
          {{ node.name }}
        </li>
      </mat-tree-node>

      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild" class="selector">
        <li>
          <div
            (click)="selectGroup(node.id)"
            class="mat-tree-node"
            matRipple
            [ngClass]="{ accent: node.id === activeNodeId }">
            <button
              class="node-toggle-btn"
              mat-icon-button
              disableRipple
              matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror icon-size-4">
                {{ nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            <ng-container *ngTemplateOutlet="groupTexture; context: { groupId: node.id }"></ng-container>
            <div>{{ node.name }}</div>
          </div>
          <ul [class.tree-invisible]="!nestedTreeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
      </mat-nested-tree-node>
    </mat-tree>
  </div>

  <div *ngIf="!data.error && !data.result">Loading…</div>

  <div *ngIf="data.error"></div>
</ng-container>
